import { faEyeSlash } from "@fortawesome/pro-regular-svg-icons/faEyeSlash";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import React, { FC } from "react";

export const EyeSlash: FC<
  JSX.IntrinsicAttributes & Omit<FontAwesomeIconProps, "icon">
> = (props) => <FontAwesomeIcon icon={faEyeSlash} {...props} />;
